function formatDateDynamic(date = new Date()) {
    return new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        numberingSystem: 'latn'
    })
        .formatToParts(date)
        .filter(p => p.type !== 'literal')
        .map(p => p.value)
        .join('/')
}

export default formatDateDynamic
